<template>
  <div>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <template v-if="showHeader">
      <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>
      <v-row class="mt-10">
        <v-col class="d-flex pt-0">
          <img
            src="../../assets/icons/sorts/resource_center.png"
            class="tcdc-resource-center-layout-icon mr-4"
          />
          <span class="text-tcdc-green bold header text-uppercase">resource center</span>
        </v-col>
      </v-row>
      <v-row class="mb-8" id="onlineEx-list">
        <v-col class="pt-0">
          <span class="text-tcdc-green header text-uppercase bold">{{$t('onlineEx.onlineEx')}}</span>
        </v-col>
      </v-row>
    </template>
    <v-row>
      <template v-for="(item, i) of allOnlineExhibitions">
        <v-col cols="12" :md="i === 0 ? 12 : 6" :key="i.toString()">
          <OnlineExhibition
            class="cursor-pointer"
            :image="item.cover_image"
            :title="item[`title_${lang}`]"
            :date="item[`publish_date_${lang}`]"
            :viewer="item.viewer"
            @click.native="exhibitionHandler(item.id)"
          />
        </v-col>
      </template>
    </v-row>
    <v-row class="mt-5">
      <v-col class="d-flex flex-1 justify-end">
        <v-pagination
                v-if="onlineExhibitionPages"
                v-model="onlineExhibitionPages.current_page"
                :length="onlineExhibitionPages.last_page"
                total-visible="7"
                prev-icon="mdi-menu-left"
                next-icon="mdi-menu-right"
                color="#2e8037"
                @input="(event) => {changePage(event); $vuetify.goTo('#onlineEx-list');}"
      ></v-pagination>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import OnlineExhibition from "../../components/cards/ExhibitionCard";
import { mapState } from "vuex";
import Loading from 'vue-loading-overlay';
import {BreadcrumbUtil} from "@/util/BreadcrumbUtil";

export default {
  components: {
    OnlineExhibition,
    Loading
  },
  props: {
    showHeader: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    exhibitionHandler(id) {
      this.$router.push({ name: 'OnlineExhibitionDetail', params: { id: id, lang: this.lang } });
    },
    changePage(page) {
      this.isLoading = true;
      this.$store.dispatch('Article/onGetAllOnlineExhibitions', { branch: this.branchId, page: page, lang: this.lang })
              .then(()=>{
                this.isLoading = false;
              });
    }
  },
  async created() {
    this.items = BreadcrumbUtil.setServiceItem(
        this.items,
        this.branchId,
        this.branchName,
        this.allBranches,
        this.lang
    )
    this.isLoading = true
    await this.$store.dispatch('Article/onGetAllOnlineExhibitions', { branch: this.branchId, page: 1, lang: this.lang })
    this.isLoading = false
  },
  computed: {
    ...mapState({
      branchName: state => state.Branch.branch_name,
      allBranches: state => state.Branch.branches,
      branchId: state => state.Branch.branch_id,
      lang: state => state.Branch.lang,
      onlineExhibitionPages: state => state.Article.allOnlineExhibitions,
      allOnlineExhibitions: state => {
        if (state.Article.allOnlineExhibitions) {
          return state.Article.allOnlineExhibitions.data
        }
      }
    }),
    branchChanged: function () {
      return this.branchName;
    }
  },
  watch: {
    branchChanged: function() {
      this.items = BreadcrumbUtil.setServiceItem(
          this.items,
          this.branchId,
          this.branchChanged,
          this.allBranches,
          this.lang
      )
      this.isLoading = true;
      this.$store.dispatch('Article/onGetAllOnlineExhibitions', { branch: this.branchId, page: 1, lang: this.lang })
      .then(()=>{
        this.isLoading = false;
      });
    }
  },
  data: () => ({
    isLoading: false,
    items: [
      {
        text: 'TCDC BANGKOK',
        disabled: false,
        to: "/home/:branch"
      },
      {
        text: "SERVICE",
        disabled: false,
        to: "/:branch/service"
      },
      {
        text: "RESOURCE CENTER",
        href: "/:branch/service/resource-center"
      },
      {
        text: "ONLINE EXHIBITION",
        disabled: true
      }
    ]
  })
};
</script>

<style>
</style>
